
export default {
  props: {
    info: {
      type: Object,
      default() {
        return {
          show: false,
          content: "",
          btnText: "好的",
          btnClick: this.closeDialog,
        };
      },
    },
  },
};
